module.exports = __webpack_public_path__ + "1a1262a6f1b8eb86c001f48e4faae481.png";